import { useState, useEffect } from 'react';
import { QuickBooksService } from '../services/quickbooks/quickbooksService';
import './quickBooksConnect.css';

export default function QuickBooksConnect({ onStatusChange }) {
  const [connected, setConnected] = useState(false);
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Check for redirect result from QB OAuth callback
    const params = new URLSearchParams(window.location.search);
    if (params.get('qb_connected')) {
      window.history.replaceState({}, '', window.location.pathname);
    }
    if (params.get('qb_error')) {
      setError('QuickBooks authorization failed. Please try again.');
      window.history.replaceState({}, '', window.location.pathname);
    }

    QuickBooksService.getStatus()
      .then(status => {
        setConnected(status.connected);
        onStatusChange?.(status.connected);
      })
      .catch(err => {
        console.error('[QB status check failed]', err);
        setConnected(false);
        onStatusChange?.(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleConnect = async () => {
    setConnecting(true);
    setError('');
    try {
      await QuickBooksService.authorize(); // redirects away
    } catch {
      setError('Failed to start QuickBooks authorization.');
      setConnecting(false);
    }
  };

  return (
    <div className="qbConnectBar">
      {connected ? (
        <span className="qbConnectedPill">✓ Connected to QuickBooks</span>
      ) : (
        <>
          <button
            className="qbConnectBtn"
            onClick={handleConnect}
            disabled={connecting}
          >
            {connecting ? 'Redirecting…' : 'Connect QuickBooks'}
          </button>
          {error && <span className="qbConnectError">{error}</span>}
        </>
      )}
    </div>
  );
}
